// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../dist/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../dist/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_container__LLJaD {
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 59px;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000;
}

.styles_right__lSJMX {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 10px 10px;
}

.styles_rotate180__Kzl-m {
  transform: rotate(180deg);
  margin-left: 10px;
}

.styles_name__Qacii {
  margin: 0 5px;
}

.styles_avatar__g3sr\\+ {
  cursor: default !important;
}

.styles_player__kexeL {
  position: absolute;
  top: 102%;
  width: 76%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 7px 17px;
  min-height: 41px;
}

.styles_playerRtl__iK9pj {
  left: 0;
}

.styles_playerLtr__9qLhT {
  right: 0;
}

.styles_player__kexeL > p {
  color: #FFF;
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.styles_hidePlayer__ZBJpB {
  visibility: hidden;
  display: none;
  width: 0px;
  height: 0px;
}

.styles_left__L3KAD {
  flex: 1 1;
  width: 66%;
  padding: 7px 10px;
  min-height: 100%;
}

@media only screen and (max-width: 800px) {
  .styles_player__kexeL {
    width: 66%;
  }
}
@media only screen and (max-width: 650px) {
  .styles_showAbsolute__WCZee {
    position: absolute;
    z-index: 1000;
  }
  .styles_hideAbsolute__rxGKl {
    display: none;
  }
  .styles_right__lSJMX {
    width: 100vw;
    border: unset !important;
  }
  .styles_right50__t2Av4 {
    width: 50vw;
    border: unset !important;
  }
  .styles_left__L3KAD {
    width: 100vw;
  }
  .styles_player__kexeL {
    width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./../src/renderer/components/Header/styles.module.scss"],"names":[],"mappings":"AAAA;EACE,sBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,WAAA;EAEA,YAAA;EACA,eAAA;EACA,MAAA;EACA,OAAA;EAGA,aAAA;AAFF;;AAIA;EACE,aAAA;EACA,2BAAA;EACA,mBAAA;EAIA,kBAAA;AAJF;;AAQA;EACE,yBAAA;EACA,iBAAA;AALF;;AAOA;EACE,aAAA;AAJF;;AAMA;EACE,0BAAA;AAHF;;AAMA;EAGE,kBAAA;EAEF,SAAA;EACA,UAAA;EACA,aAAA;EACA,2BAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;AANA;;AASA;EACE,OAAA;AANF;;AAQA;EACE,QAAA;AALF;;AAOA;EACE,WAAA;EACF,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAJA;;AAMA;EACI,kBAAA;EACF,aAAA;EACA,UAAA;EACA,WAAA;AAHF;;AAKA;EACE,SAAA;EACA,UAAA;EAEA,iBAAA;EACA,gBAAA;AAHF;;AAQA;EACA;IAAQ,UAAA;EAJN;AACF;AAMA;EACE;IACE,kBAAA;IACA,aAAA;EAJF;EAMA;IAEE,aAAA;EALF;EAOA;IACE,YAAA;IACA,wBAAA;EALF;EAOA;IACE,WAAA;IACA,wBAAA;EALF;EAOA;IACE,YAAA;EALF;EAQA;IAAQ,WAAA;EALR;AACF","sourcesContent":[".container {\n  box-sizing: border-box;\n  display:flex;\n  justify-content: space-between;\n  align-items:center;\n  width:100%;\n  // height:60px;\n  height:59px;\n  position:fixed;\n  top:0;\n  left:0;\n\n  // padding:10px 20px;\n  z-index:1000;\n}\n.right{\n  display:flex;\n  justify-content:flex-start;\n  align-items:center;\n  // width:auto;\n  // flex: 0.2;\n  // width:24%;\n  padding:10px 10px;\n  // border-left: 1px solid #b9b4b4;\n  // border-right: 1px solid #b9b4b4;\n}\n.rotate180{\n  transform:rotate(180deg);\n  margin-left:10px;\n}\n.name{\n  margin:0 5px;\n}\n.avatar{\n  cursor:default !important;\n}\n\n.player{\n  // visibility: hidden;\n  // display:none;\n  position:absolute;\n  // left:0px;\ntop:102%;\nwidth:calc(100% - 24%);\ndisplay: flex;\njustify-content: flex-start;\nalign-items:center;\npadding:7px 17px;\nmin-height:41px;\n  \n}\n.playerRtl{\n  left:0;\n}\n.playerLtr{\n  right:0;\n}\n.player>p{\n  color: #FFF;\nfont-size: 13px;\nfont-style: normal;\nfont-weight: 400;\nline-height: normal;\n}\n.hidePlayer{\n    visibility: hidden;\n  display:none;\n  width:0px;\n  height:0px;\n}\n.left{\n  flex: 1;\n  width: 66%;\n  // padding:10px 10px;\n  padding: 7px 10px;\n  min-height:100%;\n  // border-bottom:1px solid #ccc;\n  // border-right:1px solid #ccc;\n\n}\n@media only screen and (max-width: 800px) {\n.player{width: calc( 100% - 34%)}\n}\n\n@media only screen and (max-width: 650px) {\n  .showAbsolute{\n    position:absolute;\n    z-index:1000;\n  }\n  .hideAbsolute{\n    // z-index: unset;\n    display:none;\n  }\n  .right{\n    width:100vw;\n    border: unset !important;\n  }\n  .right50{\n    width:50vw;\n    border: unset !important;\n  }\n  .left{\n    width:100vw;\n\n  }\n  .player{width: calc( 100%)}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `styles_container__LLJaD`,
	"right": `styles_right__lSJMX`,
	"rotate180": `styles_rotate180__Kzl-m`,
	"name": `styles_name__Qacii`,
	"avatar": `styles_avatar__g3sr+`,
	"player": `styles_player__kexeL`,
	"playerRtl": `styles_playerRtl__iK9pj`,
	"playerLtr": `styles_playerLtr__9qLhT`,
	"hidePlayer": `styles_hidePlayer__ZBJpB`,
	"left": `styles_left__L3KAD`,
	"showAbsolute": `styles_showAbsolute__WCZee`,
	"hideAbsolute": `styles_hideAbsolute__rxGKl`,
	"right50": `styles_right50__t2Av4`
};
export default ___CSS_LOADER_EXPORT___;
